module.exports = __webpack_public_path__ + "img/dzxxwk-logo.fee18ce1.png";